var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"btn-volver",on:{"click":_vm.handleClick}},[_vm._v("Volver")])}
var staticRenderFns = []

export { render, staticRenderFns }